import { createContext } from 'react';

export const ChangePasswordContext = createContext({} as any);
